import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Shop from './pages/Shop/Shop';
import './App.css';

// Lấy basename từ package.json homepage
const basename = process.env.NODE_ENV === 'production' ? '/apple-clone-react' : '';

function App() {
  return (
    <Router basename={basename}>
      <Header />
      <Routes>
        {/* Trang chủ */}
        <Route path="/" element={<Home />} />

        {/* Trang Shop */}
        <Route path="/shop" element={<Shop />} />

        {/* Route fallback */}
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;




